// extracted by mini-css-extract-plugin
export default {"pdfContainer":"pdf_pdfContainer__tEQ+K","btn":"pdf_btn__QiPtX","loadingContainer":"pdf_loadingContainer__ZsOzn"};